import { Link } from "react-router-dom";

export const LegalDoc = ({ title, tagline, updated, sections, testid }) => (
  <div className="max-w-3xl mx-auto px-4 lg:px-8 py-14 sm:py-20" data-testid={testid}>
    <p className="eyebrow text-center">{tagline}</p>
    <h1 className="font-display text-3xl sm:text-4xl text-amber-100 text-center mt-3">{title}</h1>
    {updated && <p className="text-xs text-purple-300/50 text-center mt-3">Ultimo aggiornamento: {updated}</p>}
    <div className="mystic-card mt-10 p-7 sm:p-10 space-y-8">
      {sections.map((s, i) => (
        <section key={i} data-testid={`${testid}-section-${i}`}>
          <h2 className="font-display text-xl text-amber-200 mb-3">{s.heading}</h2>
          {s.paragraphs?.map((p, j) => (
            <p key={j} className="text-sm text-purple-100/75 leading-relaxed mb-2">{p}</p>
          ))}
          {s.items && (
            <ul className="list-disc list-inside space-y-1.5 text-sm text-purple-100/75 leading-relaxed marker:text-amber-500/60">
              {s.items.map((it, j) => <li key={j}>{it}</li>)}
            </ul>
          )}
        </section>
      ))}
      <p className="text-xs text-purple-300/50 pt-4 border-t border-amber-500/10">
        Documenti collegati: <Link to="/privacy" className="text-amber-300/80 hover:text-amber-200 underline underline-offset-2">Privacy Policy</Link> ·{" "}
        <Link to="/termini" className="text-amber-300/80 hover:text-amber-200 underline underline-offset-2">Termini e Condizioni</Link> ·{" "}
        <Link to="/disclaimer" className="text-amber-300/80 hover:text-amber-200 underline underline-offset-2">Disclaimer</Link> ·{" "}
        <Link to="/elimina-account" className="text-amber-300/80 hover:text-amber-200 underline underline-offset-2">Elimina account</Link>
      </p>
    </div>
  </div>
);
